import { tns } from 'tiny-slider/src/tiny-slider';

class BlockProduct {
	constructor(el, prevButton, nextButton) {
		this.el = el;
		this.prevButton = prevButton;
		this.nextButton = nextButton;

		const productSlider = tns({
			container: this.el,
			items: 1,
			slideBy: 'page',
			mode: 'gallery',
			autoplay: true,
			autoplayButtonOutput: false,
			speed: 400,
			controls: true,
			prevButton: this.prevButton,
			nextButton: this.nextButton,
			loop: false,
			responsive: {
				768: {
					items: 2
				},
				1024: {
					items: 3
				}
			}
		});

		return productSlider;
	}
}

export default BlockProduct;
